import { apiService } from '@/services/api/apiService';
import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';

export interface AreaCode {
    id: number | string;
    areaCodeId: number | string;
    code: string;
    areaCodeName: string;
    cityId: number | string;
    cityName: string;
}

export interface MenuPollGraphItem {
    label: string;
    liked: number;
    total: number;
    disliked: number;
    like_pct: number;
}

export interface MenuPollGraphSummary {
    like_pct: number;
    total_liked: number;
    total_swipes: number;
    total_disliked: number;
}

export interface MenuPollGraphResponse {
    taste: MenuPollGraphItem[];
    summary: MenuPollGraphSummary;
    origin_region: MenuPollGraphItem[];
}

interface MenuPollAnalyticsState {
    areaCodes: AreaCode[];
    graphData: MenuPollGraphResponse | null;
    loading: boolean;
    error: string | null;
}

const PORT = import.meta.env.VITE_USERS_PORT;
const URL = import.meta.env.VITE_API_USERS_URL;

// export const fetchAllAreaCode = createAsyncThunk<AreaCode[], void, { rejectValue: string }>(
//     'MenuPollAnalytics/fetchAllAreaCode',
//     async (_, { rejectWithValue }) => {
//         try {
//             const response = await apiService.get<{ data: AreaCode[] }>('/get_all_areacode', PORT, URL);
//             return response.data;
//         } catch (error) {
//             return rejectWithValue(error instanceof Error ? error.message : 'An error occurred');
//         }
//     }
// );

export const fetchMenuPollGraph = createAsyncThunk<
    MenuPollGraphResponse,
    { user_profile_id?: number | string; area_code_id?: number | string },
    { rejectValue: string }
>('MenuPollAnalytics/fetchMenuPollGraph', async (params, { rejectWithValue }) => {
    try {
        const response = await apiService.post<any>('/menu_poll_graph', params, PORT, URL);
        // apiService returns the raw HTTP body. Unwrap any { data: {...} } envelope so
        // graphData is always the real menu-poll graph payload (taste/summary/origin_region).
        const payload = response?.data?.data ?? response?.data ?? response;
        return payload as MenuPollGraphResponse;
    } catch (error: any) {
        return rejectWithValue(error.message || "An error occurred");
    }
});

export const menuPollAnalyticsSlice = createSlice({
    name: 'menuPollAnalytics',
    initialState: {
        areaCodes: [],
        graphData: null,
        loading: false,
        error: null,
    } as MenuPollAnalyticsState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            // .addCase(fetchAllAreaCode.pending, (state) => {
            //     state.loading = true;
            //     state.error = null;
            // })
            // .addCase(fetchAllAreaCode.fulfilled, (state, action: PayloadAction<AreaCode[]>) => {
            //     state.loading = false;
            //     state.areaCodes = action.payload;
            // })
            // .addCase(fetchAllAreaCode.rejected, (state, action) => {
            //     state.loading = false;
            //     state.error = action.payload ?? 'Unknown error';
            // })

            .addCase(fetchMenuPollGraph.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchMenuPollGraph.fulfilled, (state, action: PayloadAction<MenuPollGraphResponse>) => {
                state.loading = false;
                state.graphData = action.payload;
            })
            .addCase(fetchMenuPollGraph.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload ?? 'Unknown error';
            });
    },
});

export default menuPollAnalyticsSlice.reducer;